var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_vm._m(0),_c('div',{staticClass:"header_tlt"},[_c('h1',{class:[{ 'has-preview': _vm.hasPreview }]},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_logo"},[_c('img',{attrs:{"src":require("@/assets/images/background/bg_header_logo.svg")}})])
}]

export { render, staticRenderFns }